var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout default"},[_c('nav',{staticClass:"header"},[_c('app-header')],1),_c('main',{staticClass:"content"},[_vm._t("default")],2),_c('footer',{staticClass:"footer"},[_c('app-footer')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }